import { Component } from 'react';
import {connect} from 'react-redux';
import {actions, Errors, Form} from 'forms/rrf';
import {Col, Row} from 'react-bootstrap';
import LayoutContainer from '../../../layout/layout-container/index';
import ErrorMessages from '../../login/error-messages';
import UserTitleSelector from '../../../common/form/user/user-title-selector';
import UserFirstNameInput from '../../../common/form/user/user-first-name-input';
import UserLastNameInput from '../../../common/form/user/user-last-name-input';
import DateOfBirthSelector from '../../../common/form/user/date-of-birth-selector';
import ArrowButton from '../../../common/button-arrow';
import {savePpcUser} from '../../../../actions/ppc';
import RequiredInput from '../../../common/form/elements/required-input';
import RequiredSelect from '../../../common/form/elements/required-select';
import t from '../../../../data/translations';
import {checkPermission} from '../../../common/guards/can';

class UserDetailsForm extends Component {
  updateErrors = (field, value) => {
    this.setState({
      [field]: value
    });
  };

  onSubmit = (payLoad) => {
    this.props.dispatch(actions.submitFields('deep.admin_ppc.management.user', savePpcUser(this.props.id, payLoad)));
  };

  render() {
    const disabled = !checkPermission('manage', 'PpcUser');
    return (
      <LayoutContainer>
        <Form
          className="user-details-form"
          model="deep.admin_ppc.management.user"
          onSubmit={this.onSubmit}
        >
          <Errors className="errors" component={ErrorMessages} model="deep.admin_ppc.management.user"/>
          <Row>
            <Col lg={6}>
              <UserTitleSelector
                model="deep.admin_ppc.managements.user.title"
                disabled={disabled}
              />

              <UserFirstNameInput
                readOnly={disabled}
              />

              <UserLastNameInput
                readOnly={disabled}
              />

              <DateOfBirthSelector
                disabled={disabled}
              />

              <RequiredInput
                label="Email address"
                model=".email"
                placeholder="email"
                readOnly
              />

              <RequiredInput
                label="Mobile number"
                model=".mobile"
                placeholder="mobile"
                readOnly
              />
            </Col>

            <Col lg={6}>
              <RequiredInput
                controlId="personal_address_1"
                label="Address line 1"
                model=".address_1"
                placeholder="Address line 1"
                readOnly={disabled}
              />

              <RequiredInput
                controlId="personal_address_2"
                label="Address line 2"
                model=".address_2"
                placeholder="Address line 2"
                readOnly={disabled}
              />

              <RequiredInput
                controlId="personal_address_3"
                label="Town"
                model=".town"
                placeholder="Town"
                readOnly={disabled}
              />

              <RequiredInput
                controlId="personal_address_4"
                label="County"
                model=".county"
                placeholder="County"
                readOnly={disabled}
              />

              <RequiredInput
                controlId="eircode"
                label={t('eircode')}
                model=".eircode"
                placeholder={t('eircode')}
                readOnly={disabled}
              />

              <RequiredSelect
                controlId="kyc_status"
                hasEmptyValue={false}
                label="KYC status"
                model=".kyc_status"
                values={this.props.statuses}
                disabled={disabled}
              />
            </Col>

          </Row>
          <Row>
            <ArrowButton
              className="float-end"
              disabled={!this.props.formValid || disabled}
            >
              Save
            </ArrowButton>
          </Row>
        </Form>
      </LayoutContainer>
    );
  }
}

const mapStateToProps = state => ({
  formValid: state.deep.forms.admin_ppc.management.user.$form.valid,
});

export default connect(mapStateToProps)(UserDetailsForm);
